module.exports = __webpack_public_path__ + "static/img/01bg1.abe8906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/report/02week/01bg1.png
// module id = Z8R+
// module chunks = 0